import React, { useEffect, useState } from 'react';
import {
  TextField,
  FormControl,
  Select,
  MenuItem,
  InputLabel,
  Box,
  Grid,
  IconButton,
  Typography
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { useDispatch } from 'react-redux';
import { discipline_all, getActualSeason, season_all } from '../../../../bdd/bddSTUB.js';
import { checkExistingPlayer, fetchCompetitions, fetchTeams } from '../../../../api/index.js';
import { createPlayer, deletePlayer, updatePlayer } from '../../../../actions/players.js';
import DatePicker_Dsas from '../../../../dsasComponents/DatePicker_Dsas.js';
import { getUserProvider } from '../../../../actions/auth.js';
import SelectGroupProvider from '../../../../dsasComponents/SelectGroupProvider.js';
import PlayerCheckModal from './PlayerCheckModal.js';
import { useNavigate, useLocation  } from 'react-router-dom';
import ImageHandlerTool from '../../../components/ImageHandlerTool.js';
import { confirmActionNotification } from '../../../../actions/notifications.js';
import { useNotifications } from '../../../../v2/notifications/NotificationManager.js';

import useStyles from '../../../../styles/global-mui.js';
import DsasButton from '../../../components/DsasButton/DsasButton.js';

////////  ICONS /////////
import { faPlus, faTrashCan } from '@fortawesome/free-solid-svg-icons'
import { Can } from '../../../../permissions/Can.js';
import { PERMISSIONS } from '../../../../permissions/permissionKeys.js';
import { usePermissions } from '../../../../permissions/usePermissions.js';


const defaultPlayerData = {
  firstname: '',
  lastname: '',
  teams: [],
  teamsSeason: [],
  discipline: '',
  number: '',
  photo: '',
  birthday: null,
  nationality: '',
  size: '',
  weight: '',
  positioning: '',
  thirdPartyId: '',
  thirdPartyEntityId: '',
  provider: getUserProvider(),
};

const FormPlayer = ({ player = defaultPlayerData, onValidate = () => {} }) => {

  //bonne pratique
  const classes = useStyles();

  const navigate = useNavigate()
  const location = useLocation();
  const {addNotification} = useNotifications()

  const { getPermission } = usePermissions();
  const providerPermission = getPermission(PERMISSIONS.FILTER_PROVIDER);

  const playerFromState = location.state?.copyPlayer || player;

  const [playerData, setPlayerData] = useState(playerFromState);
  const [filters, setFilters] = useState({
    discipline: playerData.discipline || '',
    competition: '',
    teams: '',
    provider: playerData.provider || '',
    season: getActualSeason(),
  });
  const [competitions, setCompetitions] = useState([]);
  const [availableTeams, setAvailableTeams] = useState([]);
  const [showFilters, setShowFilters] = useState(false); // Gérer l'affichage des filtres pour ajouter une équipe

  const dispatch = useDispatch();

  const [existingPlayers, setExistingPlayers] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isCheckComplete, setIsCheckComplete] = useState(player._id || location.state?.copyPlayer); // Gérer l'étape de vérification

    const [isProcessing, setIsProcessing] = useState(false)

    const asDateOrNull = (v) => {
    if (!v) return null;
    const d = v instanceof Date ? v : new Date(v);
    return Number.isNaN(d.getTime()) ? null : d;
  };

  const normalizeDateNoon = (v) => {
    const d = asDateOrNull(v);
    if (!d) return null;
    const nd = new Date(d);
    nd.setHours(12, 0, 0, 0);
    return nd;
  };

  const minusOneDay = (date) => {
    const d = normalizeDateNoon(date);
    if (!d) return null;
    d.setDate(d.getDate() - 1);
    return d;
  };

  const isNationalTeam = (team) => Boolean(team?.isCountry);

  // Récupérer les détails des équipes du joueur
  /*useEffect(() => {
    const loadPlayerTeams = async () => {
        const playerTeamsDetails = await Promise.all(
            player.teams.map(async (teamId) => {
              const response = await fetchTeamById(teamId);
              return response.data[0]; // Ici on retourne directement `response.data` pour éviter l'imbrication
            })
          );

      setAvailableTeams({availableTeams : [], playerTeams : playerTeamsDetails});
    };
    loadPlayerTeams();
  }, [player.teams]);*/

  useEffect(() => {
    const normalized = (playerFromState.teamsSeason || []).map((ts) => ({
      ...ts,
      startDate: normalizeDateNoon(ts.startDate),
      endDate: normalizeDateNoon(ts.endDate),
    }));

    //handle si jamais startDate est null
    const toTime = (d) => (d ? new Date(d).getTime() : -Infinity);
    const sortedTeamsSeason = [...normalized].sort((a, b) => toTime(b.startDate) - toTime(a.startDate));

    setPlayerData((prev) => ({
      ...prev,
      teamsSeason: sortedTeamsSeason,
    }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Charger les compétitions
  useEffect(() => {
    const loadCompetitions = async () => {
      const response = await fetchCompetitions(filters);
      setCompetitions(response.data || []);
    };
    loadCompetitions();
  }, [filters]);

  // Charger les compétitions
  useEffect(() => {
    setFilters(s => ({...s, provider : playerData.provider, discipline : playerData.discipline}))
  }, [playerData.provider, playerData.discipline]);

  const loadTeams = async () => {
    const response = await fetchTeams(filters);
    setAvailableTeams(response.data || []);
  };

  // Charger les équipes en fonction de la compétition
  useEffect(() => {
    
    if (filters.competition) loadTeams();
  }, [filters.competition]);

    // Utiliser un useEffect pour surveiller les changements de playerData.teams
    useEffect(() => {
        loadTeams(); // Recharger les équipes chaque fois que playerData.teams change
    }, [playerData.teams, filters]);

  // Gérer la soumission du formulaire
  const handleSubmit = async () => {

    setIsProcessing(true)

    const sanitizedPlayerData = { ...playerData };

    // Nettoyer les champs facultatifs
    /*['number', 'size', 'weight', 'birthday'].forEach((key) => {
      if (!sanitizedPlayerData[key]) delete sanitizedPlayerData[key];
    });*/

    sanitizedPlayerData.teams = sanitizedPlayerData.teams.filter(t => t)

    // Refactoriser teamsSeason + blinder sdates
    sanitizedPlayerData.teamsSeason = sanitizedPlayerData.teamsSeason.map((t) => ({
      _id: t._id,
      team: t.team._id,
      startDate: normalizeDateNoon(t.startDate),
      endDate: normalizeDateNoon(t.endDate),
    }));

    //console.log("Submitting player data:", sanitizedPlayerData);

    // Créer ou mettre à jour le joueur
    if (player._id) {
      dispatch(updatePlayer(player._id, sanitizedPlayerData));
    } else {
      dispatch(createPlayer(sanitizedPlayerData));
    }

    // Retourner à l'URL précédente
    const previousURL = location.state?.from || '/sports/players'; // Redirige par défaut à la racine si aucune URL précédente
    setTimeout(() => {
      setIsProcessing(false); 
      onValidate();
      clearForm(); 
      navigate(previousURL)}, 
      1000)
  };

  // Gérer les changements dans les champs du formulaire
  const handleChange = (e) => {
    const { name, value } = e.target;
    setPlayerData((prev) => ({ ...prev, [name]: value }));

    if (name === 'discipline') {
      setFilters((prev) => ({ ...prev, discipline: value }));
    }

    console.log("handleChange", name, value);
    console.log("playerData", playerData);
  };

  const handleAddTeam = () => {
    setShowFilters(true); // Afficher les filtres pour ajouter une équipe
  };

  const handleSelectTeam = (teamId) => {
    const team = availableTeams.find((t) => t._id === teamId);
    if (!team) return;

    const nowNoon = normalizeDateNoon(new Date()); // midi

      setPlayerData((prev) => {
        const prevTeamsSeason = [...prev.teamsSeason];

        if (!isNationalTeam(team)) {
          const idxToClose = prevTeamsSeason.findIndex(
            (ts) => !isNationalTeam(ts.team) && !ts.endDate
          );

          if (idxToClose !== -1) {
            prevTeamsSeason[idxToClose] = {
              ...prevTeamsSeason[idxToClose],
              endDate: minusOneDay(nowNoon), // J-1 midi
            };
          }
        }

        return {
          ...prev,
          teams: [...prev.teams, team._id],
          teamsSeason: [{ team, startDate: nowNoon, endDate: null }, ...prevTeamsSeason], //  midi
        };
      });

      setShowFilters(false);
  };


  // Gestion de la suppression d'une équipe
  const handleDeleteTeam = (teamId, index) => {

    dispatch(confirmActionNotification("Êtes-vous sûr de vouloir supprimer l'équipe ?", () => {
      // Retirer l'équipe de teamsSeason
      const newTeamsSeason = playerData.teamsSeason.filter((_, idx) => idx !== index);

      // Retirer l'équipe de teams si elle n'est plus dans teamsSeason
      const isTeamStillPresent = newTeamsSeason.some((teamSeason) => teamSeason.team._id === teamId);
      const newTeams = isTeamStillPresent
        ? playerData.teams
        : playerData.teams.filter((id) => id !== teamId);

      // Mettre à jour playerData
      setPlayerData((prev) => ({ ...prev, teamsSeason: newTeamsSeason, teams: newTeams }));
    })) 

  };

  // Gestion de la sélection des dates pour les équipes
  const handleSelectDate = (index, name, date) => {
    const normalized = normalizeDateNoon(date);

    const newTeamsSeason = playerData.teamsSeason.map((t, idx) =>
      idx === index ? { ...t, [name]: normalized } : t
    );

    setPlayerData((prev) => ({ ...prev, teamsSeason: newTeamsSeason }));
  };
  
  const isValidForm = () => {
    return isValidCheckExistingPlayer() && playerData.provider && playerData.teams.length
  }

  // Réinitialiser le formulaire
  const clearForm = () => {
    setPlayerData(defaultPlayerData);
    setIsCheckComplete(player._id);
    setIsModalOpen(false);
  };

  const isValidCheckExistingPlayer = () => {
    return playerData.lastname && playerData.discipline
  }

  const handleCheckExistingPlayer = async () => {
    const { firstname, lastname, discipline } = playerData;
    const results = await checkExistingPlayer({ firstname, lastname, discipline });

    const similarPlayers = results.data
    
    if(!similarPlayers.length){
      setIsCheckComplete(true);
      setIsModalOpen(false);
    }else{
      setExistingPlayers(similarPlayers);
      setIsModalOpen(true); // Ouvrir la modal une fois que les résultats sont prêts
    }
  };

  const handleSelectOtherPlayer = (player) => {
    // Remplir les champs avec les informations du joueur sélectionné
    setPlayerData((prev) => ({
      ...prev,
      firstname: player.firstname,
      lastname: player.lastname,
      discipline: player.discipline,
      number : player.number,
      photoName: player.photoName,
      photoUrl: player.photoUrl,
      birthday: player.birthday,
      nationality: player.nationality,
      size: player.size,
      weight: player.weight,
      positioning: player.positioning,
      thirdPartyId: player.thirdPartyId,
      thirdPartyEntityId: player.thirdPartyEntityId,
      // Ne pas inclure _id, teams, teamsSeason, provider
    }));

    setIsCheckComplete(true); // L'utilisateur a passé la vérification
    setIsModalOpen(false);
  };

  const handleConfirmNone = () => {
    setIsCheckComplete(true); // Marquer que l'utilisateur a bien vérifié
    setIsModalOpen(false);
  };

  const handleConfirmSubmit = (e) => {

    e.preventDefault()

    dispatch(confirmActionNotification("Êtes-vous sûr de vouloir "+ (player._id ? "modifier" : "créer")+" le joueur ?", handleSubmit))
  }


  const handleDelete = (e) => {
    e.preventDefault()

    dispatch(confirmActionNotification("Êtes-vous sûr de vouloir supprimer le joueur ?", () => {
      dispatch(deletePlayer(player._id, (id) => {addNotification({
        title : "Suppression", 
        type : "success", 
        description : "Le joueur "+ player.lastname+" a été supprimé."
      })
      const previousURL = location.state?.from || '/sports/players';
      navigate(previousURL)
      }))
    })) 


  }

  

  return (
    <Box sx={{ paddingLeft: 3, paddingRight: 3, textAlign : 'center', animation: isProcessing ? 'pulse 1.5s infinite' : 'none',
      '@keyframes pulse': {
        '0%': { opacity: 1 },
        '50%': { opacity: 0.5 },
        '100%': { opacity: 1 }
      } }}>
      <form onSubmit={handleConfirmSubmit} autoComplete="off">
        {/*PAGE TITLE*/}
        <Box className='centered-medium-wrapper'>
          <h1 className='page-title'>{player._id ? 'Editer' : 'Créer'} un joueur</h1>
        </Box>
        <Box className='large-separator'></Box>

        <Box className='padding-wrapper'>
          <Grid container spacing={1.5} sx={{alignItems : 'flex-end'}}>
               {providerPermission?.allowed && ( 
                <Grid item xs={12} sm={12} md>
                  {/* Groupe (Provider) */}
                  <SelectGroupProvider value={playerData.provider} onChange={handleChange} className={classes.customInput} />             
                </Grid>
                )}
              <Grid item xs={12} sm={12} md>
                {/* Nom */}
                <TextField className={classes.customInput} 
                name="lastname" label="Nom" error={!playerData.lastname} fullWidth value={playerData.lastname} onChange={handleChange} />             
              </Grid>
              <Grid item xs={12} sm={12} md>
                {/* Prénom */}
                <TextField className={classes.customInput}
                name="firstname" label="Prénom" fullWidth value={playerData.firstname} onChange={handleChange} />              
              </Grid>
              <Grid item xs={12} sm={12} md>
                {/* Discipline */}
                <FormControl className={classes.customInput} fullWidth error={!playerData.discipline}>
                <InputLabel>Discipline</InputLabel>
                <Select name="discipline" value={playerData.discipline}   onChange={handleChange} label={"Discipline"}>
                    {discipline_all.map((discipline) => (
                    <MenuItem key={discipline._id} value={discipline._id}>
                        {discipline.name}
                    </MenuItem>
                    ))}
                </Select>
                </FormControl>              
              </Grid>
          </Grid>
        </Box>

        {!isCheckComplete && 
        <Box className='centered-medium-wrapper'>
          <DsasButton label="Vérifier l'existence du joueur" onClick={() => handleCheckExistingPlayer()} variant = 'alternative' disabled={!isValidCheckExistingPlayer()}/>
        </Box>
        }

        {/* Modal de vérification des doublons */}
        <PlayerCheckModal
          open={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          results={existingPlayers}
          onSelectOtherPlayer={handleSelectOtherPlayer}
          onConfirmNone={handleConfirmNone}
          actualProvider={playerData.provider}
        />

      {/* Formulaire complet, mais désactivé tant que la vérification n'est pas terminée */}
       {isCheckComplete && 
       <><Box className='large-separator'></Box>
          <Box>
            <Box className='centered-medium-wrapper'>
              {/* Image */}
              {/**DEBUG photoNAme & photoURL */}
              {/* <p>{playerData.photoName} - {playerData.photoUrl}</p> */}
              <ImageHandlerTool type='avatar' 
                initialImage={player.photoUrl || playerData.photoUrl} 
                onImageSave={(image) => setPlayerData(prev => ({ ...prev, photo: image }))} 
                displayImageLabel={false} 
                uploadButtonLabel='Editer la photo'
                />
            </Box>

            <Box className='large-separator'></Box>

            <Box className='centered-medium-wrapper'>

            <Grid container spacing={2}>
                <Grid item xs={12} sm={12} md={12}>
                  <Box> 
                    <Box className=''> 
                      <h2 className='page-subtitle'>Historique des transferts</h2>

                      {/* Bouton Ajouter une équipe */}
                      <Box className='centered-wrapper'>
                        <DsasButton icon={faPlus} label="Ajouter une équipe" onClick={() => handleAddTeam()} variant = 'secondary' disabled={showFilters}/>
                      </Box>
                      {/* Filtres pour ajouter une équipe */}
                      {showFilters && (
                          <Box className='medium-padding'>    
                            <Grid container spacing={1.5}>
                                  <Grid item xs={12} sm={12} md={4}>
                                    {/* Sélection de la compétition */}
                                    <FormControl fullwidth className={classes.customInput} sx={{ width: '100%'}}>
                                          <InputLabel>Saison</InputLabel>
                                          <Select name="season" label="Saison" value={filters.season} onChange={(e) => setFilters((prev) => ({ ...prev, season: e.target.value }))}>
                                            {season_all.map((season) => (
                                              <MenuItem key={season._id} value={season._id}>
                                                {season.name}
                                              </MenuItem>
                                            ))}
                                          </Select>
                                        </FormControl>
                                  </Grid>
                                  <Grid item xs={12} sm={12} md={4}>
                                    <FormControl fullwidth className={classes.customInput} sx={{ width: '100%'}}>
                                      <InputLabel>Compétition</InputLabel>
                                        <Select
                                          value={filters.competition}
                                          onChange={(e) => setFilters((prev) => ({ ...prev, competition: e.target.value }))}
                                        >
                                          {competitions.map((competition) => (
                                            <MenuItem key={competition._id} value={competition._id}>
                                              {competition.name}
                                            </MenuItem>
                                          ))}
                                        </Select>
                                    </FormControl>
                                  </Grid>
                                  <Grid item xs={12} sm={12} md={4}>
                                    <FormControl fullwidth className={classes.customInput} sx={{ width: '100%'}}>
                                      <InputLabel>Équipe</InputLabel>
                                      <Select
                                        value=""
                                        onChange={(e) => handleSelectTeam(e.target.value)}
                                      >
                                        {availableTeams.map((team) => (
                                          <MenuItem key={team._id} value={team._id}>
                                            {team.name}
                                          </MenuItem>
                                        ))}
                                      </Select>
                                    </FormControl>
                                  </Grid>
                            </Grid>
                          </Box>
                      )}
                      </Box>

                  <Box className='medium-padding'>  
                  {playerData.teamsSeason.map((teamInfo, idx) => {
                    const stableKey =
                      teamInfo._id ||
                      teamInfo.team?._id ||
                      `${teamInfo.team?.name ?? 'team'}-${teamInfo.startDate ?? idx}`;

                    return (
                      <React.Fragment key={stableKey}>
                        <Box>
                          {/* Nom de l'équipe */}
                          <h3 className='page-subtitle'>{teamInfo.team.name}</h3>

                          {/* Dates de début et fin */}
                          <Grid container spacing={2} sx={{ alignItems: 'flex-end' }}>
                            <Grid item xs={12} sm={5.5} md={5.5}>
                              <DatePicker_Dsas
                                className="customInput"
                                label="Date de début"
                                value={asDateOrNull(teamInfo.startDate)}
                                onChange={(date) => handleSelectDate(idx, 'startDate', date)}
                              />
                            </Grid>

                            <Grid item xs={12} sm={5.5} md={5.5}>
                              <DatePicker_Dsas
                                label="Date de fin"
                                value={asDateOrNull(teamInfo.endDate)}
                                onChange={(date) => handleSelectDate(idx, 'endDate', date)}
                              />
                            </Grid>

                            <Grid item xs={12} sm={1} md={1} sx={{alignSelf: 'center'}}>
                              <Can permission={PERMISSIONS.SPORT_PLAYER_CREATE_BUTTON_REMOVETRANSFERT}>
                                <IconButton onClick={() => handleDeleteTeam(teamInfo.team._id, idx)}>
                                  <DeleteIcon />
                                </IconButton>
                              </Can>
                            </Grid>
                          </Grid>
                        </Box>

                        {idx < playerData?.teamsSeason?.length - 1 && (
                          <>
                            <Box className='medium-padding'></Box>
                            <Box className='large-separator'></Box>
                            <Box className='small-padding'></Box>
                          </>
                        )}
                      </React.Fragment>
                    );
                  })}
                      </Box>
                  </Box>
                </Grid>
            </Grid>
            </Box>

            <Box className='large-separator'></Box>

            <Box className='medium-padding'>
                  <h2 className='page-subtitle'>Informations</h2>

                  <Box className='medium-padding'>    

                      <Grid container spacing={1.5}>
                                  <Grid item xs={12} sm={12} md={2}>
                                    {/* Date de naissance */}
                                    <DatePicker_Dsas
                                      className={classes.customInput}
                                      fullWidth
                                      label="Date de naissance"
                                      value={playerData.birthday}
                                      onChange={(date) => setPlayerData((prev) => ({ ...prev, birthday: date }))}
                                    />            
                                  </Grid>
                                  <Grid item xs={12} sm={12} md={2}>
                                    {/* Taille */}
                                    <TextField
                                      className={classes.customInput}
                                      name="size"
                                      label="Taille (cm)"
                                      fullWidth
                                      value={playerData.size || ''}
                                      onChange={handleChange}
                                    />
                                  </Grid>
                                  <Grid item xs={12} sm={12} md={2}>
                                    {/* Poids */}
                                    <TextField
                                      className={classes.customInput}
                                      name="weight"
                                      label="Poids (kg)"
                                      fullWidth
                                      value={playerData.weight || ''}
                                      onChange={handleChange}
                                    />
                                  </Grid>
                                  <Grid item xs={12} sm={12} md={2}>
                                    {/* Numéro */}
                                    <TextField className={classes.customInput} name="number" label="Numéro" fullWidth value={playerData.number!==null && playerData.number!==undefined ? playerData.number : ''} onChange={handleChange} />
                                  </Grid>
                                  <Grid item xs={12} sm={12} md={2}>
                                    {/* Position */}
                                    <TextField
                                      className={classes.customInput}
                                      name="positioning"
                                      label="Position"
                                      fullWidth
                                      value={playerData.positioning || ''}
                                      onChange={handleChange}
                                    />
                                  </Grid>
                                  <Grid item xs={12} sm={12} md={2}>
                                    {/* Nationalité */}
                                    <TextField
                                      className={classes.customInput}
                                      name="nationality"
                                      label="Nationalité"
                                      fullWidth
                                      value={playerData.nationality || ''}
                                      onChange={handleChange}
                                    />
                                  </Grid>
                      </Grid>
                    </Box>
            </Box>

            <Box className='large-separator'></Box>

            <Can permission={PERMISSIONS.AREA_THIRDPARTY}>
              <Box className='medium-padding'>
                <h2 className='page-subtitle'>Identification externe</h2>

                <Box className='medium-padding'>    

                    <Grid container spacing={1.5}>
                                <Grid item xs={6} sm={6} md={6}>
                                  {/* Id externe */}
                                    <TextField 
                                    className={classes.customInput}
                                    name="thirdPartyEntityId" label="Id externe" fullWidth value={playerData.thirdPartyEntityId || ''} onChange={handleChange} />   
                                </Grid>
                                <Grid item xs={6} sm={6} md={6}>
                                  {/* Origine id externe */}
                                    <TextField 
                                    className={classes.customInput}
                                    name="thirdPartyId" label="Origine Id externe" fullWidth value={playerData.thirdPartyId || ''} onChange={handleChange} />  
                                </Grid>
                    </Grid>
                </Box>

              </Box>         
            </Can>

            <Box className='medium-padding'>
              {playerData.teams?.length === 0 && 
                                      <Typography 
                                          className={classes.customTypoColor} 
                                          padding='10px' 
                                          justifySelf='center' 
                                          fontSize="small" 
                                          fontStyle="italic"> Veuillez ajouter une équipe pour poursuivre
                                      </Typography>}
                    {/* Boutons */}
                    <Box className='small-padding'></Box>
                    <Box className='centered-wrapper'>
                      <DsasButton type='submit' label="Valider" variant = 'alternative' disabled={!isValidForm()} />
                    </Box>
                    <Box className='small-padding'></Box>
                    {player._id &&
                    <Can permission={PERMISSIONS.SPORT_PLAYER_CREATE_BUTTON_DELETE}>
                      <Box className='centered-wrapper'>
                        <DsasButton icon={faTrashCan} label="Supprimer" variant = 'secondary' onClick={handleDelete} />
                      </Box>
                    </Can> 
                    }
            </Box>

          </Box>
        </>
        }
      </form>
    </Box>
  );
};

export default FormPlayer;
